import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../components/Layout/Loader";
import styles from "../styles/styles";
import ProductCard from "../components/Route/ProductCard/ProductCard";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";

const BestSellingPage = () => {
  const [data, setData] = useState([]);
  const INITIAL_VISIBLE = 20;
  const LOAD_MORE_STEP = 20;
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);
  const { allProducts, isLoading } = useSelector((state) => state.products);

  useEffect(() => {
    if (Array.isArray(allProducts)) {
      const sortedProducts = [...allProducts].sort(
        (a, b) => b.sold_out - a.sold_out
      );
      setData(sortedProducts);
      setVisibleCount(INITIAL_VISIBLE);
      window.scrollTo(0, 0);
    }
  }, [allProducts]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <Header activeHeading={2} />
          <br />
          <br />
          <div className={`${styles.section}`}>
            <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-2 md:gap-[20px] lg:grid-cols-4 lg:gap-[25px] xl:grid-cols-5 xl:gap-[30px] mb-12">
              {data &&
                data.slice(0, visibleCount).map((i, index) => <ProductCard data={i} key={index} />)}
            </div>
            {data.length > visibleCount && (
              <div className="flex justify-center mb-10">
                <button
                  type="button"
                  onClick={() => setVisibleCount((prev) => prev + LOAD_MORE_STEP)}
                  className="rounded-lg bg-[#38513b] px-5 py-2 text-sm font-medium text-white hover:bg-[#2f4232]"
                >
                  Load more
                </button>
              </div>
            )}
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default BestSellingPage;
